<template>
  <div
    v-if="ico"
    class="selected-project"
    :class="{
      'lizard-low-opacity': projectToDrag && projectToDrag.uid
    }"
    v-b-tooltip.hover.bottom="{ variant: 'dark' }"
    :title="msg"
    @click="fn">
    <div>
      <h1>
        <i :class="ico"></i>
      </h1>
    </div>
  </div>
  <div
    v-else
    class="selected-project"
    :style="
      tile.costLevelColor
        ? 'background: linear-gradient(180deg,' +
          tile.color +
          ' 80%, ' +
          tile.costLevelColor +
          ' 20%) !important'
        : 'background-color: ' + tile.color + ' !important'
    "
    :class="
      projectToDrag && projectToDrag.uid === tile.uid
        ? 'lizard-dragged'
        : isSelected
        ? ''
        : projectToDrag
        ? 'lizard-low-opacity'
        : ''
    "
    @click="dragProject()">
    <div
      v-if="tile.costLevelValue"
      v-b-tooltip.hover.bottom="{ variant: 'dark' }"
      :title="'Cost utilization to date: ' + tile.costLevelValue + '%'">
      {{ tile.title }}
    </div>
    <div
      v-else
      v-b-tooltip.hover.bottom="{ variant: 'dark' }"
      title="Click to select">
      {{ tile.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleTile',
  props: {
    tile: {
      type: Object
    },
    ico: {
      type: String,
      default: null
    },
    msg: {
      type: String,
      default: null
    },
    fn: {
      type: Function
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    projectToDrag() {
      return this.Store.staffingDraggedProject
    }
  },
  data() {
    return {
      isSelected: false
    }
  },
  mounted() {},
  methods: {
    dragProject() {
      if (this.projectToDrag?.uid === this.tile.uid) {
        this.$store.commit('setStaffingProjectToDrag', null)
        return
      }
      this.$store.commit('setStaffingProjectToDrag', this.tile)
    }
  },
  watch: {
    projectToDrag(projectToDrag) {
      if (!projectToDrag) {
        this.isSelected = false
      } else {
        this.isSelected = projectToDrag?.uid === this.tile?.uid
      }
    }
  }
}
</script>

<style scoped>
.selected-project {
  width: calc(100% / 6) !important;
  max-width: 105px !important;
  min-height: 64px !important;
  max-height: fit-content !important;
  color: #ffffff !important;
  margin: 4px 4px !important;
  padding: 4px !important;
  text-align: center;
  font-size: 14.5px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em;
  border-radius: 4px !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  display: inline-block;
  text-overflow: ellipsis !important;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.15) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.selected-project:hover {
  cursor: pointer;
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.2) !important;
  opacity: 0.95 !important;
}
.selected-project div {
  width: 100%;
  height: 54px !important;
  max-height: 54px !important;
  margin: 0;
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-project div h1 {
  margin: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes pulse-border {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 115, 190, 0.7), 0 4px 10px rgba(0, 0, 0, 0.15);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(0, 115, 190, 0), 0 4px 10px rgba(0, 0, 0, 0.15);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 115, 190, 0), 0 4px 10px rgba(0, 0, 0, 0.15);
  }
}
.lizard-dragged {
  transform: translateY(-2px) scale(1.05);
  border-color: #0073be !important;
  animation: pulse-border 2s infinite;
  z-index: 10;
}
.lizard-low-opacity {
  opacity: 0.4 !important;
}
</style>
